import React from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import VolunteerWorkSearch from '../../../components/Search/NLdoet/VolunteerWorkSearch';
import ProjectSearch from '../../../components/Search/NLdoet/ProjectSearch';

import './style.scss';

const NLdoetSearch = ({ entity }) => {
  const searchType = entity.getIn(['field_search_type', 0, 'value']);

  return (
    <div className={`NLdoetSearch ${searchType}`}>
      {searchType === 'volunteer_work_list' && (
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1">
              <VolunteerWorkSearch />
            </div>
          </div>
        </Container>
      )}
      {searchType === 'projects_map' && (
        <div className="NLdoetSearch__map">
          <ProjectSearch />
        </div>
      )}
      {searchType === 'projects_list' && (
        <div className="NLdoetSearch__list">
          <ProjectSearch map={false} />
        </div>
      )}


    </div>
  );
};

export default NLdoetSearch;
